export default "__VITE_ASSET__d31fe37c__"